<!--
  名称：多领域应用，底部图片区
  作者：YeMing
  时间：2021年03月23日 16:39:38
-->
<template>
  <div class="template-container">
    <div class="section-title-main">
      <h2 class="section-title"><img src="/static/images/solutions/police/application-title1.png"></h2>
      <h2 class="section-title">{{ title }}</h2>
    </div>
    <div class="section-content">
      <div class="content-item"
           v-for="(item, index) in application"
           :key="index">
        <div class="item-main"
             :style="{ backgroundImage: 'url(' + item.img + ')' }">
          <span>{{item.label}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_APPLICATION = [
  {
    label: "警用",
    img: "/static/images/industry/application/1.png"
  },
  {
    label: "测绘",
    img: "/static/images/industry/application/2.png"
  },
  {
    label: "石油",
    img: "/static/images/industry/application/3.png"
  },
  {
    label: "电力",
    img: "/static/images/industry/application/4.png"
  },
  {
    label: "应急",
    img: "/static/images/industry/application/5.png"
  },
  {
    label: "环保",
    img: "/static/images/industry/application/6.png"
  },
  {
    label: "海事",
    img: "/static/images/industry/application/7.png"
  }
];

export default {
  name: 'MultiDomainApplication',
  props: {
    title: {
      type: String,
      default: "适用多种任务场景"
    },
    application: {
      type: Array,
      default: function () {
        return DEFAULT_APPLICATION;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.template-container {
  width: 100%;
  height: 100%;

  .section-title-main {
    line-height: 30px;
    margin: 0 auto;
    background-size: contain;
    text-align: center;

    .section-title {
      font-size: 24px;
      color: #165FB5;
    }
  }

  .section-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 20px 0;
    padding: 20px 0;
    background: #fff;

    .content-item {
      width: 300px;
      height: 160px;
      padding: 10px;
      box-sizing: border-box;

      .item-main {
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 140px;
        color: #fff;
        font-size: 22px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/multiDomainApplication/index.vue